import { render } from "./FeatureDouble.vue?vue&type=template&id=069c4392"
import script from "./FeatureDouble.vue?vue&type=script&lang=js"
export * from "./FeatureDouble.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/FeatureHighlight/FeatureDouble.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "069c4392"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('069c4392', __exports__)) {
    api.reload('069c4392', __exports__)
  }
  
  module.hot.accept("./FeatureDouble.vue?vue&type=template&id=069c4392", () => {
    api.rerender('069c4392', render)
  })

}


export default __exports__